import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button } from '@mui/joy';
import { setAppLanguage, resolveAppLanguage } from '../../../i18n';

export default function PublicLanguageToggle() {
  const { t, i18n } = useTranslation('ui');
  const currentLang = resolveAppLanguage(i18n.language);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        mb: 2,
      }}
    >
      <Box
        role="group"
        aria-label={t('language.languageToggle')}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.25,
          p: 0.25,
          borderRadius: '10px',
          border: '1px solid #e5e7eb',
          backgroundColor: '#f9fafb',
        }}
      >
        <Button
          size="sm"
          variant={currentLang === 'en' ? 'solid' : 'plain'}
          color={currentLang === 'en' ? 'primary' : 'neutral'}
          onClick={() => setAppLanguage('en')}
          sx={{ minWidth: 40, fontWeight: 600, fontSize: '12px', py: 0.25, px: 0.75 }}
        >
          {t('language.english')}
        </Button>
        <Button
          size="sm"
          variant={currentLang === 'zh' ? 'solid' : 'plain'}
          color={currentLang === 'zh' ? 'primary' : 'neutral'}
          onClick={() => setAppLanguage('zh')}
          sx={{ minWidth: 40, fontWeight: 600, fontSize: '12px', py: 0.25, px: 0.75 }}
        >
          {t('language.chinese')}
        </Button>
        <Button
          size="sm"
          variant={currentLang === 'ar' ? 'solid' : 'plain'}
          color={currentLang === 'ar' ? 'primary' : 'neutral'}
          onClick={() => setAppLanguage('ar')}
          sx={{ minWidth: 40, fontWeight: 600, fontSize: '12px', py: 0.25, px: 0.75 }}
        >
          {t('language.arabic')}
        </Button>
      </Box>
    </Box>
  );
}
